import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import getColor from "@insite/mobius/utilities/getColor";

filtersAccordionStyles.accordion = mergeToNew(filtersAccordionStyles.accordion, {
    css: css`
        padding-top: 0px;
        margin-top: 10px;
        border-radius: 6px;
        overflow: hidden;
        [class^="AccordionSectionHeader"] {
            button {
                border: none;
                [class^="TypographyStyle"] {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 22px;
                }
            }
            &:not(:first-of-type) {
                button {
                    margin-top: 2px;
                }
            }
        }
        [class^="AccordionSectionPanel"] {
            background: ${getColor("secondary")};
            padding-top: 0;
            padding-bottom: 0;
            border: none;
            [class^="CheckboxStyle"] {
                > [class^="IconWrapper"] {
                    background: white;
                }
                > [class^="TypographyStyle-sc"] {
                    word-break: break-word !important;
                }
            }
        }
    `,
});
